import { jsx as _jsx } from "react/jsx-runtime";
import { TableActionButton, TableCardHeader, TableCardTitle, TableNote, TableCell, TableDropdownList, TableGroup, TableHead, TableHeadRow, TableInfo, TableLoader, TableNoData, TablePagination, TableRow, usePagination, } from './components/index.js';
import { TableProvider } from './context.js';
import { StyledTable, TableScrollableWrapper, TableWrapper } from './styled.js';
const Component = ({ maxHeight, compact, ...props }) => (_jsx(TableProvider, { compact: compact, children: _jsx(TableScrollableWrapper, { $maxHeight: maxHeight, $compact: compact, children: _jsx(StyledTable, { ...props }) }) }));
export const Table = Object.assign(Component, {
    ActionButton: TableActionButton,
    CardHeader: TableCardHeader,
    CardTitle: TableCardTitle,
    Note: TableNote,
    Cell: TableCell,
    DropdownList: TableDropdownList,
    Group: TableGroup,
    Head: TableHead,
    HeadRow: TableHeadRow,
    Info: TableInfo,
    Loader: TableLoader,
    NoData: TableNoData,
    Pagination: TablePagination,
    Row: TableRow,
    Wrapper: TableWrapper,
    usePagination,
});
